export const ProcedureData = [
    { 
        id: 1, 
        heading: "Schedule a consultation", 
        paragraph: "Follow our online platform to schedule an initial consultation." 
    },
    { 
        id: 2, 
        heading: "Consultation", 
        paragraph: "During the consultation, we’ll discuss your preparation needs and the specific forms you require assistance with. We’ll guide you through all necessary documents, explain the cost of our services and USCIS fees, and discuss any available payment plans." 
    },
    { 
        id: 3, 
        heading: "Gather all Required Documents", 
        paragraph: "With guidance from our team of immigration experts, collect all necessary documents for your specific application." 
    },
    { 
        id: 4, 
        heading: "Prepare for Application", 
        paragraph: "We’ll assist you in completing each question and filling out the government forms. Say goodbye to stress and confusion!" 
    },
    { 
        id: 5, 
        heading: "Review Application", 
        paragraph: "Our team will thoroughly review all documents and forms to ensure accuracy and completeness before submission." 
    },
    { 
        id: 6, 
        heading: "Submission of application",
        paragraph: "Once everything is reviewed, we’ll submit your application and ensure you receive copies of all documents for safekeeping." 
    },
    { 
        id: 7, 
        heading: "Dedicated Support ",
        paragraph: "Our team will support you throughout the entire process, from application submission to receiving approval and until your case is completely closed with USCIS." 
    },
]